import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import Typography from "@mui/material/Typography";
import iconExternalLink from "../../assets/icon-ExternalLink.svg";
import iconLinkSlant from "../../assets/icon-link-slant.svg";
import {
  getAiHubStatusChipSx,
  type AiHubStatusTone,
} from "./aiHubChipStyles";
import type { TaggingResultReferenceDocument } from "../../services/taggingResultsService";

type AiHubTaggingDetailHeaderProps = Readonly<{
  title: string;
  statusLabel?: string;
  statusTone?: AiHubStatusTone;
  references: readonly TaggingResultReferenceDocument[];
}>;

const referenceLinkSx = {
  display: "inline-flex",
  alignItems: "center",
  gap: 1,
  padding: "6px 12px",
  bgcolor: "#EFF6FF",
  borderRadius: "4px",
  textDecoration: "none",
  fontSize: 13,
  color: "#295EF1",
} as const;

export default function AiHubTaggingDetailHeader({
  title,
  statusLabel,
  statusTone,
  references,
}: AiHubTaggingDetailHeaderProps) {
  return (
    <Box sx={{ minWidth: 0 }}>
      <Typography
        component="h1"
        sx={{
          maxWidth: 680,
          fontSize: 20,
          lineHeight: 1.6,
          fontWeight: 600,
          color: "#1f2937",
        }}
      >
        {title}
        {statusLabel ? (
          <Chip
            component="span"
            label={statusLabel}
            size="small"
            sx={{
              ...getAiHubStatusChipSx(statusTone ?? "green"),
              ml: 1,
              verticalAlign: "middle",
            }}
          />
        ) : null}
      </Typography>
      {references.length > 0 ? (
        <>
          <Typography sx={{ mt: 2, mb: 0.75, fontSize: 12, color: "#6b7280" }}>
            Reference
          </Typography>
          <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
            {references.map((document) => (
              <Box
                key={`${document.name}-${document.url}`}
                component="a"
                href={document.url}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={`Open reference ${document.name}`}
                sx={referenceLinkSx}
              >
                <Box
                  component="img"
                  src={iconLinkSlant}
                  alt=""
                  sx={{ width: 12, height: 12, display: "block" }}
                />
                {document.name}
                <Box
                  component="img"
                  src={iconExternalLink}
                  alt=""
                  sx={{ width: 12, height: 12, display: "block" }}
                />
              </Box>
            ))}
          </Box>
        </>
      ) : null}
    </Box>
  );
}
